import * as React from 'react';
import { PrimaryButton, DefaultButton} from '@fluentui/react/lib/Button';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { APP_VERSION } from '../appConfig';
import {get_capabilities} from '../actions/entityWorker';
import {HasCapability, GetUfieldData} from '../actions/loginWorker';
import {getUserFieldDefaults} from '../actions/backgroundWorker';
import {toggleLoading, renderRefreshFields} from '../actions/navigationWorker';

export interface AppProps {
}

export interface AppState {
    clearSettings : boolean,
    checked_caps: boolean,
    checked_defaults: boolean,
    checked_dropdowns: boolean
}

class RefreshFields extends React.Component<AppProps, AppState> {

    constructor(props) {
        super(props);
        this.state = {
            clearSettings : false,
            checked_caps: false,
            checked_defaults: false,
            checked_dropdowns: false
        };
    }

    ResetAll = async () => {
        toggleLoading(true);
        renderRefreshFields(true);
        if (this.state.checked_dropdowns) {
            localStorage.removeItem('xplan_ufield_expire');
            await GetUfieldData(true);
        }

        if ( this.state.checked_defaults) {
            await getUserFieldDefaults();
        }

        if (this.state.checked_caps) {
            localStorage.removeItem('capabilities_results');
            await get_capabilities(HasCapability, ['file_email_as_docnote', 'file_email_as_task']);
            return;
        }
        location.reload();
    }

    Cancel = () => {
        location.reload();
    }

    confirmClear = (_event) => {
        this.setState({clearSettings: true});
    }

    cancelConfirmClear = (_event) => {
        this.setState({clearSettings: false});
    }

    handle_caps_checkbox_change = (_ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({checked_caps: isChecked});
    }

    handle_default_checkbox_change = (_ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({checked_defaults: isChecked});
    }

    handle_dropdown_checkbox_change = (_ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({checked_dropdowns: isChecked});
    }

    public ConfirmSettingsClear(props) {
        return(
            <div style={{ 
                padding: '16px',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '6px',
                marginBottom: '16px'
            }}>
                <p style={{ 
                    margin: '0 0 16px 0',
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#856404'
                }}>
                    Are you sure?
                </p>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <DefaultButton 
                        data-automation-id='btnCancelReset' 
                        text='No' 
                        onClick={props.cancelConfirmClear}
                        styles={{
                            root: {
                                flex: 1,
                                minHeight: '36px',
                                fontSize: '13px',
                                borderRadius: '6px',
                                border: '2px solid #5D3FD6',
                                color: '#5D3FD6',
                                fontWeight: 500,
                                backgroundColor: '#ffffff'
                            },
                            rootHovered: {
                                backgroundColor: '#f8f7fc',
                                border: '2px solid #4a32ab',
                                color: '#4a32ab'
                            }
                        }}
                    />
                    <PrimaryButton 
                        data-automation-id='btnReset' 
                        text='Yes' 
                        onClick={props.ResetAll}
                        styles={{
                            root: {
                                flex: 1,
                                minHeight: '36px',
                                fontSize: '13px',
                                borderRadius: '6px',
                                backgroundColor: '#5D3FD6',
                                border: 'none',
                                fontWeight: 500,
                                color: '#ffffff'
                            },
                            rootHovered: {
                                backgroundColor: '#4a32ab'
                            },
                            rootPressed: {
                                backgroundColor: '#3b2888'
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    public render() {
        const confirm = this.state.clearSettings;
        let confirmView = null;
        let button_style = confirm === true ? { display: 'none' } : {};

        if (confirm) {
            confirmView =  <this.ConfirmSettingsClear cancelConfirmClear={this.cancelConfirmClear} ResetAll={this.ResetAll} />;
        }
        return (
            <div style={{ 
                fontSize: '13px', 
                padding: '16px',
                paddingTop: '61px',
                backgroundColor: '#f5f5f7'
            }}>
                <div style={{ 
                    padding: '16px', 
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '2px solid #5D3FD6'
                }}>
                    <h3 style={{ 
                        marginTop: 0, 
                        marginBottom: '12px', 
                        fontSize: '14px',
                        color: '#1A1F4D',
                        fontWeight: 600
                    }}>
                        Settings
                    </h3>
                    <p style={{ marginBottom: '16px', color: '#333', fontSize: '13px' }}>
                        Please select the options to reload from your user preferences:
                    </p>
                    <div style={{ marginBottom: '16px' }}>
                        <Checkbox 
                            checked={this.state.checked_caps} 
                            label='Capabilities' 
                            onChange={this.handle_caps_checkbox_change}
                            styles={{
                                root: { marginBottom: '8px' },
                                text: { 
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#1A1F4D'
                                },
                                checkbox: {
                                    borderColor: '#5D3FD6',
                                    borderRadius: '3px'
                                }
                            }}
                        />
                        <Checkbox 
                            checked={this.state.checked_defaults} 
                            label='Field Defaults' 
                            onChange={this.handle_default_checkbox_change}
                            styles={{
                                root: { marginBottom: '8px' },
                                text: { 
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#1A1F4D'
                                },
                                checkbox: {
                                    borderColor: '#5D3FD6',
                                    borderRadius: '3px'
                                }
                            }}
                        />
                        <Checkbox 
                            checked={this.state.checked_dropdowns} 
                            label='Field Dropdown Options' 
                            onChange={this.handle_dropdown_checkbox_change}
                            styles={{
                                root: { marginBottom: '8px' },
                                text: { 
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#1A1F4D'
                                },
                                checkbox: {
                                    borderColor: '#5D3FD6',
                                    borderRadius: '3px'
                                }
                            }}
                        />
                    </div>
                    {confirmView && (
                        <div style={{ marginTop: '16px' }}>
                            {confirmView}
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                        <DefaultButton 
                            style={button_style} 
                            data-automation-id='btnNext' 
                            text='Cancel' 
                            onClick={this.Cancel}
                            styles={{
                                root: {
                                    flex: 1,
                                    minHeight: '44px',
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    border: '2px solid #5D3FD6',
                                    color: '#5D3FD6',
                                    fontWeight: 500,
                                    backgroundColor: '#ffffff'
                                },
                                rootHovered: {
                                    backgroundColor: '#f8f7fc',
                                    border: '2px solid #4a32ab',
                                    color: '#4a32ab'
                                }
                            }}
                        />
                        <PrimaryButton  
                            data-automation-id='btnContinue'
                            style={button_style}
                            disabled={!this.state.checked_caps && !this.state.checked_defaults && !this.state.checked_dropdowns}
                            text='Continue' 
                            onClick={this.confirmClear}
                            styles={{
                                root: {
                                    flex: 1,
                                    minHeight: '44px',
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    backgroundColor: '#5D3FD6',
                                    border: 'none',
                                    fontWeight: 500,
                                    color: '#ffffff'
                                },
                                rootHovered: {
                                    backgroundColor: '#4a32ab'
                                },
                                rootPressed: {
                                    backgroundColor: '#3b2888'
                                },
                                rootDisabled: {
                                    backgroundColor: '#e0e0e0',
                                    color: '#999999'
                                }
                            }}
                        />
                    </div>
                </div>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <span style={{ color: '#b0b0b0', fontSize: '12px', fontWeight: 400 }}>Version: {APP_VERSION}</span>
                </div>
            </div>
        );
    }
}

export default RefreshFields;
